module.exports = __webpack_public_path__ + "img/dcom01.b7d50c17.png";